import { request } from "@/request";

//考试详情
export function fetchExamDetail(params) {
  const { answer_id } = params;
  return request({
    url: `/answer/${answer_id}`,
    headers: {},
    params
  });
}

//考试列表
export function fetchExamList(params) {
  return request({
    url: `/answer`,
    headers: {},
    params
  });
}

//考试资格
export function fetchCanExam(params) {
  return request({
    url: `/answer/can`,
    headers: {},
    params
  });
}

//考试添加
export function fetchAddExam(data) {
  return request({
    url: `/answer`,
    method: "post",
    headers: {},
    data
  });
}

// 提交或者暂存考试
export function fetchSubmitExam(data) {
  const { answer_id } = data;
  return request({
    url: `/answer/${answer_id}`,
    method: "post",
    headers: {},
    data
  });
}
